<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row>
                <b-col>
                    <h3>Payment Report</h3>
                </b-col>
            </b-row>
            <b-card>
                <b-row>
                    <b-col cols="12">
                        <b-row class="align-items-center">
                            <b-col cols="12" sm="7" md="8">
                                <h3 class="head-text mb-2 mb-sm-0">
                                    Payment Dashboard
                                </h3>
                            </b-col>

                            <b-col
                                cols="12"
                                sm="5"
                                md="3"
                                class="mt-2 mt-sm-0 ml-auto"
                            >
                                <eb-select
                                    ref="dateRef1"
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="dateOption"
                                    v-model="selectedDate1"
                                    :selected="selectedDate1.text"
                                    @input="changeDate1"
                                ></eb-select>

                                <c-date
                                    ref="compRefs1"
                                    modalRef="modalRef1"
                                    modalId="dateModal1"
                                    @customDateRange="findDateResult1"
                                ></c-date>
                            </b-col>
                        </b-row>

                        <b-row class="mt-3">
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Collected"
                                    :value="`रु ${totalCollected}`"
                                    bottomColor="#42b039"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Pending Amount"
                                    :value="`रु ${totalPendingAmount}`"
                                    bottomColor="#ffaf37"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Refunded"
                                    :value="`रु ${totalRefunded}`"
                                    bottomColor="#ff3a3a"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Cancelled Order Amount"
                                    :value="`रु ${totalFailed}`"
                                    bottomColor="#ff3a3a"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Earning this month"
                                    :value="`रु ${totalEarning}`"
                                    bottomColor="var(--primary)"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <b-card>
                <b-row class="align-items-center payment-mode-filters">
                    <b-col
                        cols="12"
                        sm="6"
                        md="7"
                        class="payment-mode-title-col"
                    >
                        <h4 class="head-text mb-2 mb-sm-0">Payment By Mode</h4>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="3"
                        md="2"
                        class="mt-2 mt-sm-0 payment-status-col"
                    >
                        <ev-select
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :isMultiSelect="isMultiSelect"
                            placeholder="Select Status"
                            :options="paymentStatusList"
                            v-model="selectedPayment"
                            :selected="selectedPayment"
                            @input="changePaymentStatus"
                        ></ev-select>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="3"
                        md="3"
                        class="mt-2 mt-sm-0 payment-date-col"
                    >
                        <eb-select
                            ref="dateRef"
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption"
                            v-model="selectedDate"
                            :selected="selectedDate.text"
                            @input="changeDate"
                        ></eb-select>

                        <c-date
                            ref="compRefs"
                            modalRef="modalRef"
                            modalId="dateModal"
                            @customDateRange="findDateResult"
                        ></c-date>
                    </b-col>
                </b-row>

                <div class="payment-chart-container">
                    <div
                        v-if="
                            chartData &&
                            chartData.labels &&
                            chartData.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData"
                            :chart-options="barChartOptions"
                        />
                    </div>
                    <div v-else class="payment-no-data-state">
                        <h5 class="mb-0">No Data Available</h5>
                    </div>
                </div>
            </b-card>

            <!-- <b-row>
                <b-col
                    ><b-card>
                        <b-row>
                            <b-col md="4"
                                ><h4 class="head-text">
                                    USD of Tickets
                                </h4></b-col
                            >
                            <b-col md="4">
                                <eb-select
                                    class="select-background-white"
                                    id="reportData4DateFilter"
                                    type="text"
                                    label="text"
                                    v-model="selectedDate4"
                                    :selected="selectedDate4"
                                    @input="changeDate4"
                                    :options="dateOption"
                                ></eb-select>
                                <c-date
                                    ref="compRefs4"
                                    modalRef="modalRef4"
                                    modalId="dateModal4"
                                    @customDateRange="findDateResult4"
                                ></c-date>
                            </b-col>
                            <b-col md="4"
                                ><eb-select
                                    class="select-background-white"
                                    id="cusomerDropdown"
                                    type="text"
                                    label="text"
                                    v-model="selectedCustomer"
                                    :selected="selectedCustomer.text"
                                    @input="changeCustomer"
                                    :options="customerList"
                                ></eb-select
                            ></b-col>
                        </b-row>
                        <div
                            v-if="
                                pieData1 &&
                                pieData1.labels &&
                                pieData1.labels.length
                            "
                        >
                            <PieChart
                                :chart-data="pieData1"
                                :chart-options="pieChartOptions1"
                            />
                        </div> </b-card
                ></b-col>
                <b-col
                    ><b-card>
                        <b-row>
                            <b-col md="6"
                                ><h4 class="head-text">
                                    Current Year/Previous Year
                                </h4></b-col
                            >
                            <b-col md="4">
                                <eb-select
                                    class="select-background-white"
                                    id="reportData4DateFilter"
                                    type="text"
                                    label="text"
                                    v-model="selectedDate5"
                                    :selected="selectedDate5"
                                    @input="changeDate5"
                                    :options="dateOption"
                                ></eb-select>
                                <c-date
                                    ref="compRefs5"
                                    modalRef="modalRef5"
                                    modalId="dateModal5"
                                    @customDateRange="findDateResult5"
                                ></c-date>
                            </b-col>
                            <b-col md="6"
                                ><eb-select
                                    class="select-background-white"
                                    id="cusomerDropdown"
                                    type="text"
                                    label="text"
                                    v-model="selectedCustomer2"
                                    :selected="selectedCustomer2.text"
                                    @input="changeCustomer2"
                                    :options="customerList"
                                ></eb-select
                            ></b-col>
                        </b-row>
                        <BarChart
                            :chart-data="samePreviousChartData"
                            :chart-options="samePreviousChartOptions"
                        /> </b-card
                ></b-col>
            </b-row> -->
        </div>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import BarChart from "@/components/chart/BarChart";
import paymentChart from "@/utils/paymentChart";
import samePreviousYearChartData from "@/utils/samePreviousYearChartData";
import cDate from "@/components/FormElements/CustomDate.vue";
import { AtomSpinner } from "epic-spinners";
import PieChart from "@/components/chart/newPieChart.vue";

export default {
    name: "Reports",
    components: {
        ComponentHeader,
        dashboardInfoCard,
        ebSelect,
        evSelect,
        BarChart,
        cDate,
        AtomSpinner,
        PieChart,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            loading: false,
            totalCollected: 0,
            totalEarning: 0,
            totalEarningMonth: 0,
            totalFailed: 0,
            totalRefunded: 0,
            totalPendingAmount: 0,
            selectedDate: {
                text: "Today",
                value: 0,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 day's",
                    value: 6,
                },
                {
                    text: "30 day's",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",

            selectedDate1: {
                text: "Today",
                value: 0,
            },
            startDate1: "",
            endDate1: "",
            isMultiSelect: true,
            selectedPayment: [],
            paymentStatusList: [
                "All Status",
                "Collected",
                "Pending",
                "Cancelled",
                "Refunded",
                "Confirmed",
            ],
            selectedDate4: {
                text: "Today",
                value: 0,
            },
            selectedDate5: {
                text: "Today",
                value: 0,
            },
            customerList: [
                {
                    text: "All",
                    value: "all",
                },
            ],
            selectedCustomer: {
                text: "All",
                value: "all",
            },
            selectedCustomer2: {
                text: "All",
                value: "all",
            },
            usdValueLoading: false,
            samePreviousYearData: [],
            slaReportData: [],
            fields: [
                {
                    label: "Job ID",
                    key: "Job_ID",
                },
                {
                    label: "Service Provided",
                    key: "Services_Provided",
                },
                {
                    label: "Day",
                    key: "Day",
                },
                {
                    label: "Resolution Status",
                    key: "sla_resolution_status",
                },
                {
                    label: "Response Status",
                    key: "sla_response_status",
                },
            ],
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        chartData() {
            let data = this.$store.getters["partner/getChartData"];
            let paymentkey = "";
            let paymentMode = "";
            let paymentAmount = "";
            let date = "";
            if (this.$currentUserData.role == "Admin") {
                paymentkey = "admin-orderbypaymenttype-graph";
                paymentAmount = "count";
                paymentMode = "payment";
                date = "date";
            } else if (this.$currentUserData.category == "TA") {
                paymentkey = "orderbypaymenttype-graph";
                paymentAmount = "count";
                paymentMode = "payment";
                date = "date";
            } else if (this.$currentUserData.category === "SELLER") {
                paymentkey = "seller-orderbypaymenttype-graph";
                paymentAmount = "ordercount";
                date = "date";
                paymentMode = "paymenttype";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                paymentkey = "subdealer-orderbypaymenttype-graph";
                paymentAmount = "ordercount";
                date = "date";
                paymentMode = "paymenttype";
            }
            const paymentList = data?.[paymentkey] || [];

            return paymentChart(paymentList, paymentAmount, date, paymentMode);
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters["partner/getChartData"];
                                let paymentModeData =
                                    data["orderbypaymenttype-graph"];
                                let selectedPaymentData = paymentModeData.find(
                                    (el) => el.count == tooltipItem.raw,
                                );
                                let displayTooltip = `Count: ${
                                    selectedPaymentData.count
                                } \n Order Amount: ${Math.floor(
                                    selectedPaymentData.total_order_amount,
                                )}`;
                                return displayTooltip;
                            },
                        },
                    },
                },
            };
        },
        samePreviousChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        position: "left",
                        title: {
                            display: true,
                            text: "Ticket Count",
                            font: {
                                size: 15,
                            },
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y1: {
                        display: true,
                        position: "right",
                        title: {
                            display: true,
                            text: "Ticket Value",
                            font: {
                                size: 15,
                            },
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                },
                plugins: {
                    title: {
                        position: "bottom",
                        display: true,
                        font: {
                            size: 15,
                        },
                        color: "#",
                    },
                },
            };
        },
        samePreviousChartData() {
            return samePreviousYearChartData(this.samePreviousYearData);
        },
        pieData1() {
            const data =
                this.$store.getters["partner/getCustomerUsdValueOfTickets"];
            const labels = [];
            const dataSets = [
                {
                    data: [],
                    backgroundColor: [
                        "#42A5F5", // Blue
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                        "#4CAF50", // Green
                        "#FF9800", // Orange
                        "#9C27B0", // Purple
                        "#E91E63", // Pink
                        "#2196F3", // Light Blue
                        "#FFC107", // Amber
                    ],
                    hoverBackgroundColor: [
                        "#64B5F6", // Hover Blue
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                        "#81C784", // Hover Green
                        "#FFB74D", // Hover Orange
                        "#BA68C8", // Hover Purple
                        "#F06292", // Hover Pink
                        "#64B5F6", // Hover Light Blue
                        "#FFEB3B", // Hover Amber
                    ],
                },
            ];
            const dataKey =
                this.selectedCustomer.value === "all"
                    ? "all-usd-of-tickets"
                    : "usd-of-tickets";
            if (data && data[dataKey] && data[dataKey].length > 0) {
                if (
                    this.selectedCustomer &&
                    this.selectedCustomer.value === "all"
                ) {
                    const firstItem = data[dataKey][0] || {};

                    Object.keys(firstItem).forEach((el) => {
                        labels.push(el || ""); // Push an empty string if key is missing
                    });

                    Object.keys(firstItem).forEach((el) => {
                        dataSets[0].data.push(
                            firstItem[el] ? firstItem[el] : 0,
                        );
                    });
                } else {
                    data[dataKey].map((el) => {
                        labels.push(
                            `${this.selectedCustomer.value}: (Open Invoices)`,
                        );
                        labels.push(
                            `${this.selectedCustomer.value}: (Closed Invoices)`,
                        );
                        dataSets[0].data.push(parseInt(el.open_invoices || 0));
                        dataSets[0].data.push(
                            parseInt(el.closed_invoices || 0),
                        );
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        pieChartOptions1() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },
    },
    methods: {
        // Helper method to get API key prefix based on user role/category
        getApiKeyPrefix() {
            if (this.$currentUserData.role === "Admin") {
                return "admin-";
            } else if (this.$currentUserData.category === "SELLER") {
                return "seller-";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                return "subdealer-";
            }
            return ""; // TA category
        },
        // Helper method to get API variables based on user role/category
        getApiVariables(additionalVars = {}) {
            const baseVars = { ...additionalVars };
            if (this.$currentUserData.role === "Admin") {
                return baseVars;
            } else if (this.$currentUserData.category === "TA") {
                return { ...baseVars, tenant: this.userId };
            } else if (
                this.$currentUserData.category === "SELLER" ||
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                return {
                    ...baseVars,
                    userId: this.userId,
                    tenant: this.$currentUserData.tenant,
                };
            }
            return baseVars;
        },
        // Generic method to get date data
        getDateDataGeneric(dateData, startDateProp, endDateProp) {
            if (dateData === "custom") {
                return {
                    fromDate: this[startDateProp],
                    toDate: this[endDateProp],
                };
            }
            if (dateData === 1) {
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
            }
            const data = {
                fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
            };
            if (typeof dateData === "number") {
                data.fromDate = moment()
                    .subtract(dateData, "days")
                    .format("YYYY-MM-DD");
                return data;
            } else if (typeof dateData === "object") {
                return dateData;
            }
            return data;
        },
        // Helper method to assign dashboard data
        assignDashboardData(data, prefix) {
            const totalCollectedKey = prefix
                ? `${prefix}total-collected`
                : "total-collected";
            const totalOrdersKey = prefix
                ? `${prefix}total-orders`
                : "total-orders";
            const totalPendingKey = prefix
                ? `${prefix}total-pending-collection`
                : prefix === "admin-"
                  ? "admin-total-pending-collection"
                  : "total-pending-collection";
            const totalRefundedKey = prefix
                ? `${prefix}total-refunded`
                : "total-refunded";
            const totalCancelledKey = prefix
                ? `${prefix}total-payment-cancelled`
                : "total-payment-cancelled";

            // Handle different property names for collected amount
            if (prefix === "admin-" || prefix === "") {
                this.totalCollected =
                    data[totalCollectedKey]?.totalcollected || 0;
            } else {
                this.totalCollected =
                    data[totalCollectedKey]?.total_collected || 0;
            }

            // Handle totalEarning - SELLER uses .toFixed(2), others use number
            const earningValue = +data[totalOrdersKey]?.total_order_amount || 0;
            if (prefix === "seller-") {
                this.totalEarning = earningValue.toFixed(2);
            } else {
                this.totalEarning = earningValue;
            }

            this.totalFailed = data[totalCancelledKey]?.total_collected || 0;
            this.totalRefunded = data[totalRefundedKey]?.total_collected || 0;
            this.totalPendingAmount =
                data[totalPendingKey]?.total_collected || 0;
        },
        getProperDate1(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("YYYY-MM-DD");
            } else return "Unavailable";
        },
        findDateResult1(e) {
            ((this.startDate1 = e.fromDate),
                (this.endDate1 = e.toDate),
                this.dashboardReport());
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
            } else {
                this.dashboardReport();
            }
        },
        getDateData1(dateData) {
            return this.getDateDataGeneric(dateData, "startDate1", "endDate1");
        },
        async dashboardReport() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData1(this.selectedDate1.value);
            const baseVariables = this.getApiVariables(dateData);

            // Define API keys based on prefix
            const keys = [
                "total-collected",
                "total-pending-collection",
                "total-refunded",
                "total-payment-cancelled",
                "total-orders",
            ];

            const payload = {
                items: keys.map((key) => ({
                    key: prefix ? `${prefix}${key}` : key,
                    variables: baseVariables,
                })),
            };

            const data = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                payload,
            );

            // Assign dashboard data
            this.assignDashboardData(data, prefix);

            // Handle totalEarningMonth calculation
            const totalOrdersKey = prefix
                ? `${prefix}total-orders`
                : "total-orders";
            const monthVariables = this.getApiVariables({
                fromDate: this.getProperDate1(
                    moment().startOf("month").toISOString(),
                ),
                toDate: this.getProperDate1(
                    moment().add(+1, "days").toDate().toISOString(),
                ),
            });

            const payload1 = {
                items: [
                    {
                        key: totalOrdersKey,
                        variables: monthVariables,
                    },
                ],
            };

            const data1 = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                payload1,
            );

            this.totalEarningMonth = (
                +data1[totalOrdersKey]?.total_order_amount || 0
            ).toFixed(2);
        },
        getProperDate1(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("YYYY-MM-DD");
            } else return "Unavailable";
        },
        findDateResult(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.fetchPaymentChart();
        },
        changeDate(e) {
            if (e.value === "custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                this.fetchPaymentChart();
            }
        },
        changePaymentStatus(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedPayment = e;
                } else {
                    this.selectedPayment = ["All Status"];
                }
            } else {
                this.selectedPayment = e;
            }
            this.fetchPaymentChart();
        },
        getStatusData(statusData) {
            let data = {};
            if (
                statusData.length === 0 ||
                statusData.some((el) => el === "All Status")
            ) {
                this.paymentStatusList.forEach((el, index) => {
                    if (el !== "All Status") {
                        data[`status${index}`] = el;
                    }
                });
            } else {
                statusData.forEach((el, index) => {
                    data[`status${index + 1}`] = el;
                });
            }
            return data;
        },
        getDateData(dateData) {
            return this.getDateDataGeneric(dateData, "startDate", "endDate");
        },

        async fetchPaymentChart() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData(this.selectedDate.value);
            const statusData = this.getStatusData(this.selectedPayment);

            // Build variables based on role/category
            let variables = { ...dateData, ...statusData };

            // For SELLER and DISTRIBUTOR/DEALER/SUB_DEALER, statusData is not included
            if (
                this.$currentUserData.category === "SELLER" ||
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                variables = { ...dateData, ...statusData };
            }

            variables = this.getApiVariables(variables);

            const chartKey = prefix
                ? `${prefix}orderbypaymenttype-graph`
                : "orderbypaymenttype-graph";

            const payload = {
                items: [
                    {
                        key: chartKey,
                        variables: variables,
                    },
                ],
            };

            await this.$store.dispatch("partner/fetchChart", payload);
        },
        getDateInfo(dateData) {
            if (dateData === "custom") {
                return {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
            }
            if (typeof dateData === "number") {
                return {
                    fromDate: moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
            }
            return null;
        },
        changeDate4(e) {
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            this.fetchCustomerUsdValueOfTickets();
        },
        changeCustomer(value) {
            this.selectedCustomer = value;
            this.fetchCustomerUsdValueOfTickets();
        },
        findDateResult4(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.fetchCustomerUsdValueOfTickets();
        },
        async fetchCustomerUsdValueOfTickets() {
            this.usdValueLoading = true;
            let dataList = [
                {
                    key: "usd-of-tickets",
                    variables: {
                        ...this.getDateInfo(this.selectedDate4.value),
                        Customer: this.selectedCustomer.value,
                    },
                },
            ];

            if (this.selectedCustomer.value === "all") {
                dataList = [
                    {
                        key: "all-usd-of-tickets",
                        variables: {
                            ...this.getDateInfo(this.selectedDate4.value),
                        },
                    },
                ];
            }
            const data = await this.$store.dispatch(
                "partner/fetchCustomerUsdValueOfTickets",
                {
                    items: dataList,
                },
            );
            this.usdValueLoading = false;
        },

        changeCustomer2(value) {
            this.selectedCustomer2 = value;
            this.fetchSameTimePreviousYearData();
        },
        async fetchSameTimePreviousYearData() {
            let payload = {};
            if (this.selectedCustomer2.value === "all") {
                payload = {
                    key: "all-same-time-previous-year",
                    variables: {
                        fromDate: "2024-01-20",
                        toDate: moment().format("YYYY-MM-DD"),
                    },
                };
            } else {
                payload = {
                    key: "same-time-previous-year",
                    variables: {
                        fromDate: "2024-01-20",
                        toDate: moment().format("YYYY-MM-DD"),
                        Customer: this.selectedCustomer2.value,
                    },
                };
            }

            await this.$store
                .dispatch("partner/fetchBulkAnalyticReport", {
                    items: [payload],
                })
                .then((data) => {
                    this.samePreviousYearData = data[payload.key];
                });
        },
    },

    async mounted() {
        const data = await this.$store.dispatch(
            "partner/fetchBulkAnalyticReport",
            {
                items: [
                    {
                        key: "customer-list",
                        variables: {},
                    },
                ],
            },
        );
        const customerData = data["customer-list"].map((el) => {
            return {
                text: el.Customer_Name,
                value: el.Customer_Name,
            };
        });
        this.customerList = [...this.customerList, ...customerData];
        this.dashboardReport();
        this.fetchPaymentChart();
        this.fetchCustomerUsdValueOfTickets();
        this.fetchSameTimePreviousYearData();
    },
};
</script>
<style scoped>
.head-text {
    margin-bottom: 0px;
    font-size: 1.125rem;
    font-weight: 600;
    color: #000000;
}
.green-chart-icon i {
    background: #def6ee;
    text-align: center;
    color: #65d27d;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.order-price-heading {
    line-break: anywhere;
    line-height: 24px;
}

.select-background-white {
    background-color: #fff;
}

.payment-mode-title-col {
    flex-shrink: 0;
}

.payment-mode-filters .payment-date-col {
    flex-shrink: 0;
    min-width: 140px;
}

.payment-status-col :deep(.v-select .vs__dropdown-toggle) {
    min-height: 38px;
}

.payment-status-col :deep(.vs__selected-options) {
    flex-wrap: wrap;
}

.payment-chart-container {
    min-height: 300px;
}

.payment-no-data-state {
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
</style>
